// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"InfoBlock_infoBlock__XMfnt","content":"InfoBlock_content___9XNc","arrow":"InfoBlock_arrow__b_J1A"};